const flashCards = [
  {
    no: 1,
    front: "What is a defining physical characteristic of a hornbill?",
    back: "A long, curved beak topped with a casque.",
  },
  {
    no: 2,
    front:
      "What role do hornbills play in their ecosystem, leading to them being called 'farmers of the forest'?",
    back: "They spread seeds of fruits they eat.",
  },
  {
    no: 3,
    front: "What are some threats facing hornbill populations?",
    back: "Deforestation and hunting for their casque and feathers.",
  },
];

export default flashCards;
